<template>
  <div class="bg">
    <div class="Index" v-show="indexStatus">
      <div class="banner">
        <img class="bgImg" src="../assets/image/banner.jpg" alt />
        <div class="bgImgBottom"></div>

        <div class="theme">
          <div class="themeTime">
            <div class="countdown">
              <div class="countdownLi">{{ hours }}</div>
              <div class="countdownLi">{{ minutes }}</div>
              <div class="countdownLi">{{ seconds }}</div>
            </div>
          </div>

          <div class="themeInput" v-if="playGameStatus">
            <p class="themeNum">剩余抽奖次数：{{ prizeNum }}</p>
          </div>

          <div class="playGame" @click="login">
            <img src="../assets/image/login_btn.gif" alt />
          </div>

          <div class="playGame" v-if="playGameStatus">
            <!-- <p class="playGameNum">剩余抽奖次数：{{prizeNum}}</p> -->

            <img src="../assets/image/playgame.gif" @click="playGameFunc" alt />
          </div>

          <p class="getAPPID">
            如何获取ID?
            <span @click="toTutorial">点击这里 ></span>
          </p>
        </div>

        <div class="playGameRecord1">
          <img src="../assets/image/red_cotent.png" @click="openActive" alt />
        </div>

        <div class="playGameRecord2">
          <img src="../assets/image/red_record.png" @click="toRecord" alt />
        </div>

        <div class="notice">
          <div class="noticeT">
            <p>活动说明</p>
          </div>
          <div class="noticeM">
            <div class="read">
              <div class="readLi">
                1.会员当日存款50元且累计投注达到500元以上即可获得抢红包机会;
              </div>
              <div class="readLi">2.所获红包金额一倍流水,即可申请提款;</div>
              <div class="readLi">
                3.会员投注均由系统自动统计,若有任何异议,以王妃直播为准;
              </div>
              <div class="readLi">
                4.王妃直播的所有优惠均是为玩家而设,同一账号,同一姓名,同一住址,同一IP,同一号码,同一银行卡账户均视为同一人,如发现任何团队或个人以不诚实的方式套取红利,威胁滥用公司优惠等行为,公司保留冻结并取消该团队或者个人账户及账户的结余权利;
              </div>
              <div class="readLi">
                5.王妃直播保留对活动的最终解释权,以及再无通知的情况下修改或终止活动的权利,适用于所有优惠。
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 登录弹窗 -->
      <div class="login" v-if="!loginStatus">
        <div class="loginTips">
          <img src="../assets/image/login.png" alt />

          <div class="loginYes" @click="loginFunc"></div>
          <div class="loginClose" @click="closelogin"></div>
          <div class="tutorial" @click="toTutorial"></div>

          <div class="themeInput">
            <input
              type="text"
              v-model="vipAccount"
              placeholder="请输入您的ID"
            />
          </div>
        </div>
      </div>

      <!-- 红包雨 -->
      <div class="redRain" v-show="redRainArray.length > 0">
        <div class="redRainLiWidth"></div>
        <template v-for="(item, index) in redRainArray">
          <img
            class="redRainLi"
            :src="item.src"
            :style="{ top: item.top, left: item.left, transition: item.speed }"
            :key="index"
          />
        </template>
      </div>

      <div class="redOperate" v-if="redStatus">
        <!-- 打开红包弹窗 -->
        <div class="openred" v-if="openredStatus">
          <img src="../assets/image/openred.png" alt />

          <div class="openredArea" @click="toGetRedFunc"></div>

          <div class="closeredArea" @click="closeredFunc"></div>
        </div>
        <!-- 获奖弹窗 -->
        <div class="getred" v-show="getredStatus">
          <img src="../assets/image/getred.png" alt />

          <div class="getredMoney">
            <i>￥</i>
            <p>{{ winMoney }}</p>
          </div>

          <div class="getredArea" @click="getRedFunc"></div>

          <div class="closeGetRedArea" @click="closeGetredFunc"></div>
        </div>

        <!-- 失败弹窗 -->
        <div class="losered" v-if="loseredStatus">
          <img src="../assets/image/losered.png" alt />

          <div class="loseredArea" @click="loseredFunc"></div>
        </div>
      </div>
      <!-- 提示注册弹窗 -->
      <div class="register" v-if="registerStauts">
        <div class="registerTips">
          <img src="../assets/image/register.png" alt />

          <div class="registerYes" @click="registerFunc"></div>
          <div class="registerClose" @click="closeRegister"></div>
          <div class="registerNo" @click="closeRegister"></div>
        </div>
      </div>
    </div>

    <!-- appid获取教程 -->
    <div class="tutorialAlert" v-if="tutorialStatus">
      <div class="tutorialAlertTips">
        <img src="../assets/image/tutorial.png" alt />

        <div class="closeTutorialIcon" @click="closeTutorial"></div>
      </div>
    </div>

    <!-- 裸聊奖品 -->
    <div class="award" v-if="awardStatus">
      <div class="awardAlert">
        <img
          v-show="awardType == 'GIFT1'"
          src="../assets/GIFT1.png"
          @click="openliao"
          alt
        />
        <img
          v-show="awardType == 'GIFT2'"
          src="../assets/GIFT2.png"
          @click="openliao"
          alt
        />
        <img
          v-show="awardType == 'GIFT3'"
          src="../assets/GIFT3.png"
          @click="openliao"
          alt
        />
        <img
          v-show="awardType == 'GIFT4'"
          src="../assets/GIFT4.png"
          @click="openliao"
          alt
        />
        <img
          v-show="awardType == 'GIFT5'"
          src="../assets/GIFT5.png"
          @click="openliao"
          alt
        />

        <div class="closeawardArea" @click="closeliao"></div>
      </div>
    </div>

    <div class="recordPage" v-show="recordStatus">
      <div class="recordChild">
        <div class="recordClose" @click="closeRecord"></div>
        <div class="record">
          <div class="recordC" @scroll="handleScroll">
            <div class="recordScroll">
              <template v-for="(item, index) in recordList">
                <div class="recordLi" :key="index">
                  <div class="recordTd" style="width: 30%">
                    {{ item.valid_date }}
                  </div>
                  <div class="recordTd" style="width: 50%">
                    获得{{ item.money }}红包
                  </div>
                  <div class="recordTd" style="width: 20%">
                    {{ item.status }}
                  </div>
                </div>
              </template>

              <div class="recordLiHeight"></div>
            </div>
          </div>
        </div>

        <!-- <div class="backArea" @click="back">&lt; 返回</div> -->
      </div>
    </div>

    <div class="active" v-show="activeStatus">
      <div class="activeChild">
        <div class="activeClose" @click="closeActive"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getRule,
  getPacket,
  getHistory,
  getConfig,
  getreRemaincount,
  llRemainCount,
  getllAward,
} from "@/api/red";

import { Message } from "element-ui";
import redImg from "../assets/image/red.png";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      indexStatus: true,
      redTimer: null,
      redRainArray: [],
      registerStauts: false,
      luoliaoStatus: false,
      playGameStatus: false,
      redStatus: false,
      openredStatus: false,
      getredStatus: false,
      loseredStatus: false,
      recordStatus: false,
      activeStatus: false,
      tutorialStatus: false,
      awardStatus: false,
      loginStatus: true,
      prizeNum: 0,
      winMoney: 0,
      step: 0,
      recordTimer: null,
      ruleList: [],
      recordList: [],
      huiyinniaoUrl: "",
      vipAccount: "",
      registerUrl: "",
      hours: 0,
      minutes: 0,
      seconds: 0,

      isLoadingMore: false, // 是否正在加载更多
      recordNum: 1, // 当前页码
      hasMore: true, // 是否还有更多数据
      awardType: "",
    };
  },
  mounted() {
    setInterval(() => {
      this.hours = this.countdown().hours;
      this.minutes = this.countdown().minutes;
      this.seconds = this.countdown().seconds;
    }, 1000);
    // 规则
    getRule().then((res) => {
      this.ruleList = res.data;
    });

    // 配置地址
    getConfig({ appid: process.env.VUE_APP_APPID }).then((res) => {
      res.data.forEach((v) => {
        if (v.key == "hyn_url") {
          this.huiyinniaoUrl = v.value;
        }
        if (v.key == "register_url") {
          this.registerUrl = v.value;
        }
      });
    });
  },

  methods: {
    // 红包雨动画
    redRainFunc() {
      this.redRainArray = [];
      let owindow_width = document.documentElement.clientWidth;
      window.onresize = () => {
        return (() => {
          owindow_width = document.documentElement.clientWidth;
        })();
      };

      let redWidth = document.querySelector(".redRainLiWidth").offsetWidth;

      clearInterval(this.redTimer);
      this.redTimer = setInterval(() => {
        let red1 = parseInt(Math.random() * (owindow_width - redWidth));
        let red2 = parseInt(Math.random() * redWidth * 2 + 1);
        let speed = parseInt(Math.random() * 3 + 10);

        this.redRainArray.push({
          src: redImg,
          left: red1 + "px",
          top: 0,
          speed: 0,
        });

        if (this.redRainArray[this.redRainArray.length - 2]) {
          this.redRainArray[this.redRainArray.length - 2] = {
            src: redImg,
            top: 4000 + "px",
            left: red1 - red2,
            speed: speed + "s all",
          };
        }

        if (this.redRainArray.length > 25) {
          // this.redRainArray = []
          this.redRainArray[this.redRainArray.length - 1] = {
            src: redImg,
            top: 4000 + "px",
            left: red1 - red2,
            speed: speed + "s all",
          };
          clearInterval(this.redTimer);
        }
      }, 200);

      setTimeout(() => {
        this.redRainArray = [];
        clearInterval(this.redTimer);
      }, 4500);
    },
    // 登录
    login() {
      this.loginStatus = false;
    },
    // 跳转登录
    loginFunc() {
      if (!this.vipAccount) {
        Message({
          message: "请输入您的ID！",
          type: "warning",
          duration: 5 * 1000,
        });
        return false;
      }

      getreRemaincount({
        appid: process.env.VUE_APP_APPID,
        username: this.vipAccount,
      }).then((res) => {
        if (res.code == 400) {
          this.registerStauts = true;
          this.loginStatus = true;
        } else {
          if (res.data.count === 0) {
            llRemainCount({
              appid: process.env.VUE_APP_APPID,
              username: this.vipAccount,
            }).then((res) => {
              this.luoliaoStatus = true;
              this.prizeNum = res.data.count;
              this.loginStatus = true;
              this.playGameStatus = true;
            });
          } else {
            this.prizeNum = res.data.count;
            this.loginStatus = true;
            this.playGameStatus = true;
          }
        }
      });
    },
    // 关闭登录
    closelogin() {
      this.loginStatus = true;
    },
    // 打开教程
    toTutorial() {
      this.tutorialStatus = true;
      this.loginStatus = true;
    },

    // 开始游戏
    playGameFunc() {
      if (this.prizeNum == 0) {
        Message({
          message: "没有抽奖次数！",
          type: "warning",
          duration: 5 * 1000,
        });
        return false;
      }

      this.redRainFunc();

      setTimeout(() => {
        this.redStatus = true;
        this.openredStatus = true;
      }, 3000);
    },
    // 关闭拆红包界面
    closeredFunc() {
      this.redStatus = false;
      this.openredStatus = false;

      // 关掉红包雨
      this.redRainArray = [];
      clearInterval(this.redTimer);
    },
    // 关闭收红包界面
    closeGetredFunc() {
      this.redStatus = false;
      this.openredStatus = false;
      this.getredStatus = false;
    },
    // 去拆完红包界面
    toGetRedFunc() {
      if (this.luoliaoStatus) {
        getllAward({
          appid: process.env.VUE_APP_APPID,
          username: this.vipAccount,
        }).then((res) => {
          this.openredStatus = false;
          this.awardStatus = true;
          this.winMoney = 0;
          this.prizeNum = 0;
          this.awardType = res.data.money;
        });
      } else {
        getPacket({
          appid: process.env.VUE_APP_APPID,
          username: this.vipAccount,
        }).then((res) => {
          // 判断是否中奖
          if (res.data.money == 0) {
            this.openredStatus = false;
            this.loseredStatus = true;
          } else {
            this.openredStatus = false;
            this.getredStatus = true;
            this.winMoney = res.data.money;
          }
          this.prizeNum = res.data.count;
        });
      }
    },

    // 关闭获取教程弹窗
    closeTutorial() {
      this.tutorialStatus = false;
    },
    // 收下红包
    getRedFunc() {
      this.redStatus = false;
      this.openredStatus = false;
      this.getredStatus = false;
    },
    // 未中奖
    loseredFunc() {
      this.redStatus = false;
      this.openredStatus = false;
      this.loseredStatus = false;
    },
    // 跳转注册
    registerFunc() {
      window.open(this.registerUrl);
    },
    // 关闭注册
    closeRegister() {
      this.registerStauts = false;
    },
    // 跳转抽奖记录
    toRecord() {
      if (!this.vipAccount) {
        this.loginStatus = false;
        return false;
      }

      this.recordStatus = true;

      this.recordNum = 1;
      this.recordList = [];
      this.isLoadingMore = false;
      this.hasMore = true;
      this.historyRecord();
    },

    // 红包记录
    historyRecord() {
      if (this.isLoadingMore || !this.hasMore) return;
      this.isLoadingMore = true;

      getHistory({
        appid: process.env.VUE_APP_APPID,
        username: this.vipAccount,
        page: this.recordNum,
      }).then((res) => {
        this.recordList.push(...res.data.datas);
        this.recordNum += 1;
        // 如果新数据长度小于pageSize，则说明没有更多数据
        this.hasMore = res.data.datas.length === 10;
        this.isLoadingMore = false;
      });
    },
    // 红包记录滚动
    handleScroll(event) {
      event.preventDefault();

      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 当滚动到底部时加载更多
      if (scrollTop + clientHeight >= scrollHeight - 5 && this.hasMore) {
        this.historyRecord();
      }
    },

    // 清除文字滚动
    clearRecordTimer() {
      clearInterval(this.recordTimer);
    },
    // 红包倒计时
    countdown() {
      const now = new Date();
      const nextDay = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1,
      );
      const difference = nextDay - now; // 计算时间差（毫秒）

      // 将时间差转换为时分秒格式
      const seconds = Math.floor((difference / 1000) % 60)
        .toString()
        .padStart(2, "0");

      const minutes = Math.floor((difference / 1000 / 60) % 60)
        .toString()
        .padStart(2, "0");
      const hours = Math.floor((difference / 1000 / 60 / 60) % 24)
        .toString()
        .padStart(2, "0");

      // 返回格式化的剩余时间
      return {
        hours,
        minutes,
        seconds,
      };
    },
    openliao() {
      window.location.href = this.huiyinniaoUrl;
    },
    closeliao() {
      this.awardStatus = false;
      this.redStatus = false;
    },
    // 转化金额单位
    sumMoney(val) {
      let result = "";
      if (val < 10000) {
        result = val + "元+";
      } else {
        result = Math.floor(val / 10000) + "万+";
      }
      return result;
    },
    // 打开活动内容
    openActive() {
      if (!this.vipAccount) {
        this.loginStatus = false;
        return false;
      }

      this.activeStatus = true;
    },
    // 关闭活动内容
    closeActive() {
      this.activeStatus = false;
    },
    // 关闭红包记录
    closeRecord() {
      this.recordStatus = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.bg {
  position: relative;
}

.Index {
  position: relative;
}

.banner {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 1454px;

  .bgImg {
    width: 100%;
  }

  .bgImgBottom {
    background: url("../assets/image/bg_content.jpg") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    flex: 1;
    margin-top: -2px;
  }

  .theme {
    width: 274px;
    height: 394px;
    position: absolute;
    transform: translate(-50%, 0);
    top: 251px;
    left: 50%;
    z-index: 1;

    .themeTime {
      background: url("../assets/image/time.png");
      background-size: 100% 100%;
      width: 246px;
      height: 50px;
      display: flex;
      align-items: center;
      position: absolute;
      top: 565px;
      left: 50%;
      transform: translate(-50%, 0);
    }

    .countdownTitle {
      color: #2f2b2a;
      font-size: 17px;
      margin-right: 38px;
      width: 81px;
    }

    .countdown {
      display: flex;
      align-items: center;
      gap: 9px;
      width: 232px;
      padding-left: 120px;

      .countdownLi {
        color: #fff;
        font-size: 15px;
        border-radius: 8px;
        width: 26px;
        height: 25px;
        line-height: 25px;
        flex-shrink: 0;
        margin-right: 3px;
        letter-spacing: 4px;
      }

      .countdownText {
        color: #2f2b2a;
        font-size: 14px;
        line-height: 26px;
      }
    }

    .themeInput {
      width: 540px;
      height: 88px;
      position: absolute;
      top: 165px;
      left: 50%;
      transform: translate(-50%, 0);
      display: flex;
      align-items: center;
      justify-content: center;

      .line {
        width: 1px;
        height: 30px;
        background: #fff;
        position: absolute;
        top: 1px;
        right: 75px;
      }

      input {
        background: none;
        border: 0;
        color: #fff;
        font-size: 23px;
        width: 219px;
        text-align: center;
        margin-top: -5px;

        &::placeholder {
          color: #fff;
          font-size: 23px;
        }
      }

      input[type="text"]:focus {
        outline: none;
      }

      .themeNum {
        font-size: 16px;
        color: #fff;
        margin-top: -8px;
      }
    }

    .getAPPID {
      font-size: 16px;
      position: absolute;
      bottom: -359px;
      left: 17px;
      color: #fff;
      width: 251px;

      span {
        color: #fcff3a;
      }
    }

    .rob {
      position: absolute;
      top: 682px;
      left: 610px;
      width: 87px;
      height: 87px;
      border-radius: 50%;
      cursor: pointer;
    }
  }

  .playGame {
    position: absolute;
    top: 628px;
    left: 50%;
    transform: translate(-50%, 0);

    .playGameNum {
      width: 341px;
      height: 50px;
      line-height: 50px;
      margin-left: -9px;
      color: #fff;
      font-size: 19px;
      position: absolute;
      top: -191px;
      left: 0;
    }

    img {
      width: 325px;
      cursor: pointer;
    }
  }
}

.notice {
  background: url("../assets/image/active.png");
  position: absolute;
  background-size: 100% 100%;
  width: 540px;
  height: 390px;
  top: 1030px;
  left: 50%;
  transform: translate(-50%, 0);

  .noticeT {
    position: relative;
    margin: 42px 0 12px 0;
    color: #d11303;

    p {
      font-size: 27px;
      font-weight: bold;
    }
  }

  .noticeM {
    line-height: 27px;

    .read {
      text-align: left;
      padding: 0px 44px;

      .readLi {
        color: #2f2a27;
        font-size: 15px;
        line-height: 27px;
      }
    }
  }
}

.turn {
  width: 100%;
}

.redRain {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;

  .redRainLi {
    position: absolute;
    width: 50px;
  }

  .redRainLiWidth {
    position: fixed;
    top: -10000px;
    left: -10000px;
    width: 50px;
  }
}

.redOperate {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2;

  .openred {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 400px;
    }

    .openredArea {
      position: absolute;
      left: 51px;
      bottom: 105px;
      width: 300px;
      height: 403px;
      cursor: pointer;
    }

    .closeredArea {
      position: absolute;
      left: 175px;
      bottom: 32px;
      width: 50px;
      height: 50px;
      cursor: pointer;
    }
  }

  .getred {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 400px;
    }

    .getredArea {
      position: absolute;
      left: 123px;
      bottom: 189px;
      width: 145px;
      height: 35px;
      cursor: pointer;
      border-radius: 25px;
    }

    .closeGetRedArea {
      position: absolute;
      left: 178px;
      bottom: 33px;
      width: 46px;
      height: 49px;
      cursor: pointer;
      border-radius: 25px;
    }

    .getredMoney {
      position: absolute;
      left: 50%;
      bottom: 401px;
      transform: translate(-50%, 0);
      height: 116px;
      line-height: 116px;
      margin-left: 5px;

      p {
        font-size: 88px;
        font-weight: bold;
        background: linear-gradient(180deg, #df180c, #fc6b5d);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      i {
        position: absolute;
        left: -31px;
        bottom: -17px;
        background: linear-gradient(180deg, #df180c, #fc6b5d);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 35px;
        display: block;
        font-weight: bold;
        font-style: normal;
      }
    }
  }

  .losered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 350px;
    }

    .loseredArea {
      position: absolute;
      left: 62px;
      bottom: 160px;
      width: 227px;
      height: 56px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}

.liao {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 4;

  .liaoC {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
  }

  img {
    width: 400px;
  }

  .liaoArea {
    position: absolute;
    left: 217px;
    bottom: 258px;
    width: 374px;
    height: 75px;
    cursor: pointer;
    border-radius: 25px;
  }

  .openliao {
    position: absolute;
    left: 34px;
    bottom: 9px;
    width: 332px;
    height: 57px;
    cursor: pointer;
    border-radius: 25px;
  }

  .closeliao {
    position: absolute;
    right: 8px;
    top: 5px;
    width: 45px;
    height: 45px;
    cursor: pointer;
    border-radius: 25px;
  }

  p {
    font-size: 72px;
    position: absolute;
    left: 50%;
    bottom: 181px;
    transform: translate(-50%, 0);
    height: 116px;
    line-height: 116px;
    font-weight: bold;
    color: #e93534;

    span {
      position: absolute;
      left: -26px;
      bottom: 36px;
      font-size: 29px;
      line-height: 20px;
      display: block;
      color: #c57016;
      font-weight: normal;
    }
  }
}

.register {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;

  .registerTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 500px;
    }

    .registerYes {
      position: absolute;
      right: 98px;
      bottom: 205px;
      width: 305px;
      height: 56px;
      cursor: pointer;
      border-radius: 25px;
    }

    .registerNo {
      position: absolute;
      right: 98px;
      bottom: 141px;
      width: 305px;
      height: 56px;
      cursor: pointer;
      border-radius: 25px;
    }

    .registerClose {
      position: absolute;
      right: 221px;
      bottom: 41px;
      width: 60px;
      height: 60px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}

.recordPage {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;

  .recordChild {
    background: url("../assets/image/record.png") no-repeat;
    background-size: contain;
    width: 511px;
    height: 593px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .recordClose {
      width: 60px;
      height: 60px;
      position: absolute;
      left: 225px;
      bottom: 32px;
    }

    .record {
      position: absolute;
      top: 123px;
      left: 41px;

      .recordC {
        width: 411px;
        height: 300px;
        overflow-y: auto;
        position: absolute;
        top: 5px;
        left: 12px;

        .recordScroll {
          width: 100%;

          .recordLi {
            display: flex;
            align-items: center;
            height: 32px;

            .recordTd {
              color: #000;
              font-size: 15px;
              padding-bottom: 15px;
            }
          }
        }

        .recordLiHeight {
          position: fixed;
          top: -10000px;
          left: -10000px;
          height: 32px;
        }
      }
    }

    .backArea {
      position: fixed;
      top: 30px;
      left: 40px;
      color: #fff;
      font-size: 32px;
      cursor: pointer;
    }

    .turnArea {
      position: absolute;
      bottom: 95px;
      left: 30px;
      width: 1020px;
      height: 75px;
      cursor: pointer;
    }
  }
}

.active {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  overflow-y: auto;
  z-index: 2;
  overscroll-behavior: contain;

  .activeChild {
    background: url("../assets/image/activeC.png") no-repeat;
    background-size: 100%;
    width: 588px;
    height: 1114px;
    position: absolute;
    top: 50px;
    left: 50%;
    transform: translate(-50%, 0);
    padding-bottom: 50px;

    .activeClose {
      width: 67px;
      height: 67px;
      position: absolute;
      top: 52px;
      right: 53px;
    }

    .activeC {
      background: #fff;
      border-radius: 19px;
      margin: 0 14px;
    }

    .activeT {
      position: relative;
      margin: 423px 0 14px 0;
      color: #f31b06;

      img {
        width: 201px;
        height: 48px;
        margin-top: -24px;
      }
    }

    .activeM {
      line-height: 27px;

      .read {
        text-align: left;
        padding: 0px 18px;

        .readLi {
          color: #2f2a27;
          font-size: 14px;
          line-height: 22px;
        }
      }

      .table {
        border: 1px solid #e9331d;
        width: 398px;
        margin: 0 auto 5px;
        border-radius: 20px;

        .thead {
          display: flex;
          align-items: center;
          width: 100%;
          height: 42px;
          background: linear-gradient(180deg, #fe6150, #fcca35);
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;

          .th {
            flex: 1;
            flex-shrink: 0;
            color: #fff;
            font-size: 22px;
            border-right: 1px solid #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
          }

          .th:last-child {
            border-right: 0;
          }
        }

        .tbody {
          display: flex;
          width: 100%;

          .td {
            flex: 1;
            flex-shrink: 0;
            color: #e92a17;
            font-size: 17px;
            border-right: 1px solid #b32316;
            border-bottom: 1px solid #b32316;
            min-height: 26px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .td:last-child {
            border-right: none;
          }
        }

        .tbody:last-child {
          .td {
            border-bottom: none;
          }
        }
      }
    }
  }
}

.bg_content {
  background: url("../assets/image/bg_content.jpg") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  top: 759px;
  width: 100%;
  height: 563px;
}

.playGameRecord1 {
  position: absolute;
  left: 10px;
  top: 860px;
  transform: translate(0, -50%);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  flex-direction: column;

  img {
    width: 112px;
    margin-top: 10px;
  }
}

.playGameRecord2 {
  position: absolute;
  right: 10px;
  top: 860px;
  transform: translate(0, -50%);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  flex-direction: column;

  img {
    width: 112px;
    margin-top: 10px;
  }
}

.marquee {
  position: relative;
  transition: top 0.2s linear;
}

.tutorialAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;

  .tutorialAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 500px;
    }

    .tutorialAlertYes {
      position: absolute;
      left: 76px;
      bottom: 144px;
      width: 248px;
      height: 62px;
      cursor: pointer;
      border-radius: 12px;
    }

    .closeTutorialIcon {
      position: absolute;
      right: 14px;
      top: 12px;
      width: 40px;
      height: 40px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}

.login {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 4;

  .loginTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 500px;
    }

    .loginYes {
      position: absolute;
      left: 97px;
      bottom: 205px;
      width: 305px;
      height: 54px;
      cursor: pointer;
      border-radius: 12px;
    }

    .loginClose {
      position: absolute;
      left: 220px;
      bottom: 42px;
      width: 58px;
      height: 57px;
      cursor: pointer;
      border-radius: 12px;
    }

    .tutorial {
      position: absolute;
      left: 252px;
      bottom: 175px;
      width: 80px;
      height: 22px;
    }

    .themeInput {
      position: absolute;
      top: 392px;
      left: 50%;
      width: 263px;
      transform: translate(-50%, 0);

      input {
        background: none;
        border: 0;
        color: #ffffff;
        font-size: 20px;
        width: 220px;
        text-align: center;

        &::placeholder {
          color: #ffffff;
          font-size: 20px;
        }
      }

      input[type="text"]:focus {
        outline: none;
      }
    }
  }
}

.award {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;

  .awardAlert {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 450px;
    }

    .awardLiao {
      position: absolute;
      left: 70px;
      bottom: 45px;
      width: 298px;
      height: 60px;
      cursor: pointer;
      border-radius: 25px;
    }

    .awardArea {
      position: absolute;
      left: 40px;
      bottom: 36px;
      width: 372px;
      height: 50px;
      cursor: pointer;
      border-radius: 25px;
    }

    .closeawardArea {
      position: absolute;
      right: 7px;
      top: 44px;
      width: 61px;
      height: 56px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}
</style>
